import React, { useEffect } from 'react';
import {
    TextField,
    Box,
    Grid,
    Typography,
    FormControl, InputLabel, Select, MenuItem, Button,
} from '@mui/material';

const boxContent = {
    display: 'flex',
    gap: 20,
    alignItems: 'center'
}
const typographyText = {
    textAlign: 'left',
    width: '15%'
}
const inputArr = [
    {
        value: ""
    }
];
const AllotmentCredentialItem = (props) => {
    const [textOrDropdown, setTextOrDropdown] = React.useState('');

    const handleChangeSelect = (event) => {
        setArr(inputArr)
        setTextOrDropdown(event.target.value)
    }
    const [arr, setArr] = React.useState(inputArr);
    useEffect(() => {
        // console.log("props123",props);
        
        if(props.moduleInfo){
            const parseData = JSON.parse(props.moduleInfo.relationshipRemarks)
            // console.log("parseData",parseData);
            if(parseData != null || parseData != undefined){
                setTextOrDropdown(parseData && parseData.type)
                setArr(parseData.options)
            } 
        }
    },[])
    const addInput = () => {        
        setArr(s => {
            return [
                ...s,
                {
                    value: ""
                }
            ];
        });
    };
    useEffect(() => {
        // console.log(arr, textOrDropdown);
        const data = {
            type: textOrDropdown,
            options: textOrDropdown === 'dropdown' ? arr : []
        }
        props.credentailsSettingItem(data)
    }, [arr, textOrDropdown])
    const removeInput = (index) => {
        const values = [...arr];
        values.splice(index, 1);
        setArr(values);
    }

    const handleChange = e => {
        e.preventDefault();
        const index = e.target.id;
        setArr(s => {
            const newArr = s.slice();
            newArr[index].value = e.target.value.trim();
            return newArr;
        });
    };
    // console.log("arr",arr);
    
    return (
        <>
            <Grid item align="center" xs={12} >
                <Box style={boxContent}>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', gap: '1%' }}>
                        <FormControl fullWidth={false} size="small" sx={{ width: '13%' }}>
                            <InputLabel id="demo-simple-select-label">
                                Please Select
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={textOrDropdown}
                                label="Please Select"
                                onChange={(e) => handleChangeSelect(e)}>
                                <MenuItem
                                    key={'freeText'}
                                    value={'freeText'}>
                                    Free Text
                                </MenuItem>
                                <MenuItem
                                    key={'dropdown'}
                                    value={'dropdown'}>
                                    Dropdown
                                </MenuItem>
                            </Select>
                        </FormControl>
                        {textOrDropdown === "dropdown" &&
                            <Button
                                color="primary"
                                variant="contained"
                                sx={{ minWidth: '40px' }}
                                onClick={addInput}>ADD</Button>}
                    </Box>
                </Box>
            </Grid>
            <Grid item align="center" xs={12}>
                <Box sx={{ width: "100%", display: 'flex', flexDirection: 'row', gap: '1%',marginTop: 2,marginBottom:2, flexWrap: 'wrap' }}>
                    {textOrDropdown === "dropdown" && <>                        
                        {arr.map((item, i) => {
                            return (
                                <>
                                    <TextField
                                        onChange={handleChange}
                                        value={item.value}
                                        id={i}
                                        label={'value'}
                                        size="small"
                                        sx={{ width: '10%', mb:1 }}
                                    />
                                    <Button
                                        color="secondary"
                                        sx={{ minWidth: '40px', mb:1 }}
                                        variant="contained" onClick={() => removeInput(i)}>-</Button>
                                </>
                            );
                        })} </>}
                </Box>
            </Grid>
        </>
    )
}

export default AllotmentCredentialItem;